import { getIncomingParent } from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { type CourseState } from '@editor2/types/courseState';

import { getDeletedModifiedConflict } from '../helpers/createConflictHelper';
import { getUpdatedValuesAndConflicts } from '../helpers/detectConflictHelper';

export class ElementConflictDetector {
	detectConflicts = (state: CourseState, node) => {
		const { family_id, ...element } = node;

		// if current is deleted but incoming modified
		if (state.changes.elements[family_id]?.includes(ChangesStatus.Deleted)) {
			const conflict = getDeletedModifiedConflict({
				attribute: 'elements',
				entityType: element.type,
				id: family_id,
				state,
				incoming: { ...element, family_id }
			});

			state.conflicts = [...state.conflicts, conflict];
			return;
		}

		const initial = state.initialCourse.elements.entities[family_id];
		const current = state.elements.entities[family_id];
		const incoming = { family_id, ...element };

		const payload = { initial, current, incoming, attributes: { ...element }, state };

		const data = getUpdatedValuesAndConflicts(payload);
		return data;
	};

	applyDiffToInitial = ({ state, family_id, updatedInitial, nodes }) => {
		const initial = state.initialCourse.elements.entities[family_id];
		const initPageId =
			initial?.initPageId ||
			getIncomingParent({ state, attribute: 'elements', id: family_id, nodes })?.family_id;

		state.initialCourse.elements.entities[family_id] = { family_id, ...updatedInitial, initPageId };
	};

	applyDiffToCurrent = ({ state, family_id, updatedCurrent, nodes }) => {
		const initial = state.initialCourse.elements.entities[family_id];
		const initPageId =
			initial?.initPageId ||
			getIncomingParent({ state, attribute: 'elements', id: family_id, nodes })?.family_id;

		state.elements.entities[family_id] = { family_id, ...updatedCurrent, initPageId };
	};

	applyConflict = ({ state, conflicts }) => {
		state.conflicts = [...state.conflicts, ...conflicts];
	};
}
